module.exports = __webpack_public_path__ + "static/img/znsy_p1.dc62abb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/znsy_p1.png
// module id = vysg
// module chunks = 19